import React from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "./CreateTitleModal.css";
import Spinner from "react-bootstrap/Spinner";

function CreateTitleModal(props) {
  return (
    <Modal
      backdrop="static"
      show={props.showCreateModal}
      onHide={props.handleCloseCreateModal}
      centered
    >
      <Modal.Header>
        <Modal.Title>Create new title</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Control
          autoFocus
          value={props.creatingTitle}
          type="text"
          placeholder="Unique title"
          onChange={props.handleEnterCreatingTitle}
        />
        <Form.Control
          className="btm_form"
          value={props.creatingProdTitle}
          type="text"
          placeholder="Unique production title"
          onChange={props.handleEnterCreatingProdTitle}
        />
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={props.handleCloseCreateModal}
          disabled={props.isLoading}
        >
          Close
        </Button>
        <Button
          variant="info"
          onClick={props.handleFireCreateTitle}
          disabled={props.isLoading}
        >
          Create
        </Button>
        <div className="spinner_container">
          {" "}
          {props.isLoading && <Spinner animation="grow" />}
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default CreateTitleModal;
